import { createFileRoute } from '@tanstack/react-router'

import { Spinner } from '@damis/ui/components/spinner'
import { requireSession } from '@/features/auth/require-session'
import { SignedInLayout } from '@/features/auth/signed-in-layout'

/**
 * Pathless layout for every signed-in screen. `beforeLoad` runs before any child loads: without a
 * session (after trying a refresh) the visitor goes to `/login?redirect=…`; otherwise the member
 * and their org are in the cache before anything renders.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context, location }) => requireSession(context.queryClient, location.href),
  pendingComponent: () => (
    <div className="flex min-h-dvh items-center justify-center bg-background">
      <Spinner className="size-6 text-muted-foreground" />
    </div>
  ),
  component: SignedInLayout,
})
